/**
 * SSE のリモートイベントを購読する React hook.
 *
 * `registerSyncListener` の薄いラッパー。ハンドラは ref で保持するので
 * 毎レンダー渡す関数が変わっても再登録されない（安全に closure を捕まえられる）。
 */

import { useEffect, useRef } from 'react'

import { registerSyncListener, type SyncEvent } from '@/api/sync-events'

export const useSyncEventListener = (handler: (event: SyncEvent) => void): void => {
  const ref = useRef(handler)

  useEffect(() => {
    ref.current = handler
  }, [handler])

  useEffect(() => {
    return registerSyncListener((event) => ref.current(event))
  }, [])
}
